const API_BASE_URL = (import.meta.env.VITE_AXON_API_BASE_URL || "https://api.axonleads.ru").replace(/\/$/, "");

export class CrmApiError extends Error {
  constructor(message, details = {}) {
    super(message);
    this.name = "CrmApiError";
    Object.assign(this, details);
  }
}

async function crmRequest(idToken, path, options = {}) {
  let response;
  try {
    response = await fetch(`${API_BASE_URL}${path}`, {
      method: options.method || "GET",
      headers: {
        Authorization: `Bearer ${idToken}`,
        ...(options.body ? { "Content-Type": "application/json" } : {}),
        ...(options.headers || {}),
      },
      body: options.body ? JSON.stringify(options.body) : undefined,
      cache: "no-store",
      credentials: "omit",
      redirect: "error",
      referrerPolicy: "no-referrer",
    });
  } catch {
    throw new CrmApiError("Нет связи с CRM. Проверьте интернет и попробуйте ещё раз.");
  }
  const payload = await response.json().catch(() => null);
  if (!response.ok) {
    const error = payload?.error || {};
    throw new CrmApiError(
      typeof error.message === "string" ? error.message : "Не получилось сохранить изменение.",
      {
        status: response.status,
        code: error.code,
        resource: error.resource,
        usage: error.usage,
        limit: error.limit,
        recoveryAction: error.recoveryAction,
      },
    );
  }
  return payload;
}

export function convertLeadToDeal(idToken, assignmentId, input = {}) {
  return crmRequest(idToken, `/v1/leads/${assignmentId}/convert`, {
    method: "POST",
    body: input,
  });
}

export function fetchCrmDeals(idToken, stage = "all", offset = 0) {
  const params = new URLSearchParams({ stage, offset: String(offset), limit: "50" });
  return crmRequest(idToken, `/v1/crm/deals?${params.toString()}`);
}

export function updateCrmDeal(idToken, dealId, input) {
  return crmRequest(idToken, `/v1/crm/deals/${dealId}`, {
    method: "PATCH",
    body: input,
  });
}

export function addCrmNote(idToken, dealId, body) {
  return crmRequest(idToken, `/v1/crm/deals/${dealId}/notes`, {
    method: "POST",
    body: { body },
  });
}

export function fetchToday(idToken) {
  return crmRequest(idToken, "/v1/today");
}

export function recordLeadContact(idToken, assignmentId, input, idempotencyKey) {
  return crmRequest(idToken, `/v1/leads/assignments/${assignmentId}/contact`, {
    method: "POST",
    body: input,
    headers: { "Idempotency-Key": idempotencyKey },
  });
}
